module.exports = __webpack_public_path__ + "res/img_back.c3c6e5c13a9529d9f96573f7acf3d3fc.png";